import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "button"];

  /**
   * Control on keyup to catch what the user intent to do.
   */
  press(e) {
    let target = e.target;
    // Break if Shift, Tab, CMD, Option, Control.
    if (e.keyCode === 16 || e.keyCode == 9 || e.keyCode == 224 || e.keyCode == 18 || e.keyCode == 17) {
      return;
    }

    // On Backspace or left arrow, go to the previous field.
    if ( (e.keyCode === 8 || e.keyCode === 37) && target.previousElementSibling && target.previousElementSibling.tagName === "INPUT" ) {
      target.previousElementSibling.select();
    } else if (e.keyCode !== 8 && target.nextElementSibling) {
      target.nextElementSibling.select();
    }

    // If the target is populated to quickly, value length can be > 1
    if (target.value.length > 1 ) {
      this.splitNumber(e);
    }
  }

  /**
   * Better control on Focus
   * - don't allow focus on other field if the first one is empty
   * - don't allow focus on field if the previous one if empty (debatable)
   * - get the focus on the first empty field
   */
  focus(e) {
    let dig = e.target.dataset.dig;

    // If the focus element is the first one, do nothing
    if (dig == 1) return;

    // If value of first input is empty, focus it.
    if (this.inputTarget.value == '') {
      this.inputTarget.focus();
    }

    // If value of a previous input is empty, focus it.
    // To remove if you don't wanna force user respecting the fields order.
    if (e.target.previousElementSibling.value == '') {
      e.target.previousElementSibling.focus();
    }
  }

  splitNumber(e) {
    let data = e.data || e.target.value; // Chrome doesn't get the e.data, it's always empty, fallback to value then.
    if (!data) return; // Shouldn't happen, just in case.
    if (data.length === 1) return; // Here is a normal behavior, not a paste action.
    
    this.popuNext(e.target, data);
    this.buttonTarget.focus();
  }

  popuNext(target, data) {
    target.value = data[0]; // Apply first item to first input
    data = data.substring(1); // remove the first char.
    if (target.nextElementSibling && data.length) {
      // Do the same with the next element and next data
      this.popuNext(target.nextElementSibling, data);
    }
  }
}